'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ager;

var _componentType = require('component-type');

var _componentType2 = _interopRequireDefault(_componentType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function parseDate(year, month, day) {
  if ((0, _componentType2.default)(year) === 'array') return parseDate.apply(undefined, _toConsumableArray(year));
  if ((0, _componentType2.default)(year) !== 'number') return null;

  if (!month || month > 12) throw new RangeError('Month value is not correct');

  if (!day || day > new Date(year, month, 0).getDate()) {
    throw new RangeError('Day value is not correct');
  }

  var date = new Date(year, month - 1, day);
  date.setFullYear(year);
  return date;
}

function ager(year) {
  var today = new Date();

  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var birthday = (0, _componentType2.default)(year) === 'date' ? year : parseDate.apply(undefined, [year].concat(args));

  if (!birthday) throw new TypeError('Value is not a date');
  if (birthday > today) throw new RangeError('Date cannot be a birthday');

  return today.getFullYear() - birthday.getFullYear() - (today.getMonth() < birthday.getMonth() ? 1 : 0) - (today.getMonth() === birthday.getMonth() && today.getDate() < birthday.getDate() ? 1 : 0);
}
module.exports = exports['default'];
